module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.stopPropagation();
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.stopPropagation();
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('h2', {
    staticClass: "modal-header"
  }, [_vm._v(_vm._s(_vm.item.name) + "\n          "), _c('a', {
    staticClass: "model-close-button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._l((_vm.targets), function(target) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.item.canTransferTo(target.characterId)),
        expression: "item.canTransferTo(target.characterId)"
      }],
      staticClass: "button transfer",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.item.transfer(target)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": target.emblemPath
      }
    }), _vm._v(" "), _c('span', [_vm._v("Transfer ➡ " + _vm._s(target.className))])])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.canEquip),
      expression: "item.canEquip"
    }],
    staticClass: "icon equipped"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.equipped),
      expression: "item.equipped"
    }],
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unEquip($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("bookmark")]), _vm._v("\n              Equipped\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.equipped),
      expression: "!item.equipped"
    }],
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.equip($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("bookmark_border")]), _vm._v(" Unequipped\n            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.key),
      expression: "item.key"
    }],
    staticClass: "icon favorite"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.favorited),
      expression: "item.favorited"
    }],
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unFavorite($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("star")]), _vm._v("\n              Favorited\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.favorited),
      expression: "!item.favorited"
    }],
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.favorite($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("star_border")]), _vm._v(" Unfavorited\n            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.canToggleLock),
      expression: "item.canToggleLock"
    }],
    staticClass: "icon lock"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.isLocked),
      expression: "item.isLocked"
    }],
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unLock($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock")]), _vm._v(" Locked\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.isLocked),
      expression: "!item.isLocked"
    }],
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lock($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock_open")]), _vm._v("\n              Unlocked\n            ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.key),
      expression: "item.key"
    }]
  }, [_vm._l((_vm.tagsDefinitions), function(ref) {
    var tag = ref[0];
    var tagDefinition = ref[1];

    return _c('div', [_c('div', {
      staticClass: "tag",
      class: {
        'enabled': _vm.item.hasTag(tag)
      },
      style: ({
        'background-color': tagDefinition.color
      }),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleTag(tag)
        }
      }
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.item.hasTag(tag)),
        expression: "item.hasTag(tag)"
      }],
      staticClass: "fa fa-check"
    }), _vm._v("\n                " + _vm._s(tag) + "\n              ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n              You can edit tags in  "), _c('a', {
    staticClass: "padded",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'settings'
        })
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("settings")])])])], 2)], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f00311a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TagsSelector.vue
// module id = 558
// module chunks = 1